// For backwards compatibility; we make sure the NEXT_PUBLIC_API_URL does not include the /graphql suffix
const sanitizeUrl = (url: string) => {
  if (url.endsWith('/graphql')) {
    return url.replace('/graphql', '')
  }
  return url
}

const getApiUrl = () => {
  const url = process.env.NEXT_PUBLIC_API_URL
  if (!url) {
    throw new Error('NEXT_PUBLIC_API_URL is not set.')
  }
  return sanitizeUrl(url)
}

export const API_URL = getApiUrl()
export const GRAPHQL_API_URL = `${API_URL}/graphql`

export const ON_SIGN_IN_REDIRECT_URL = `/on-sign-in` // It is redirected by NextJS to the API server.
export const SSO_CALLBACK_URL = `/sso-callback`
